import { PagesBlogManagerUiInput } from "./Input";
import { Box, Typography } from "@dealer-center/core-components";

export const PagesBlogManagerUiDisplay = () => {
  return (
    <Box>
      <Box sx={{ display: "flex", flexDirection: "column", gap: 1, mb: 2 }}>
        <Typography variant={"h1"}>BlogManager</Typography>
        <Typography variant={"body-md"}>
          Here is some basic content for your site
        </Typography>
      </Box>
      <PagesBlogManagerUiInput />
    </Box>
  );
};
